import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const AddTeamIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 13.834V12.4809C2 11.6527 2.37285 10.8406 3.12645 10.4971C4.04567 10.0781 5.14808 9.83398 6.33333 9.83398C7.1632 9.83398 7.95247 9.95365 8.66667 10.1692"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.33333 7.83268C7.622 7.83268 8.66667 6.78801 8.66667 5.49935C8.66667 4.21068 7.622 3.16602 6.33333 3.16602C5.04467 3.16602 4 4.21068 4 5.49935C4 6.78801 5.04467 7.83268 6.33333 7.83268Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.66602 3.26367C10.6298 3.55053 11.3327 4.44337 11.3327 5.50038C11.3327 6.55739 10.6298 7.45025 9.66602 7.73712"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 9.83398V13.834M10 11.834H14"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
